<template>
    <li class="slice-reinsurance__column" :data-testid="`slice-reinsurance-column--${index}`">
        <PrismicImage
            v-if="isFilled.image(item.brandLogo)"
            :field="item.brandLogo"
            :alt="item.brandLogo.alt ?? ''"
            sizes="140px"
            :class="['slice-reinsurance__logo', {'slice-reinsurance__logo--bigger': item.isBigger, 'slice-reinsurance__logo--color': withColor}]"
            :data-testid="`slice-reinsurance-logo--${index}`"
        />
        <blockquote v-if="isFilled.keyText(item.quote)" class="slice-reinsurance__quote" :data-testid="`slice-reinsurance-quote--${index}`">
            <p>“{{ item.quote }}”</p>
        </blockquote>
        <p v-if="isFilled.keyText(item.quoteAuthor)" class="slice-reinsurance__author" :data-testid="`slice-reinsurance-author--${index}`">
            {{ item.quoteAuthor }}
        </p>
    </li>
</template>

<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import {PrismicImage} from '@prismicio/vue';
    import type {ReinsuranceSliceReinsuranceWithColumnsItem} from '@prismicio-types';

    defineProps<{
        item: ReinsuranceSliceReinsuranceWithColumnsItem;
        index: number;
        withColor: boolean;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-reinsurance {
        &__column {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex: 0 0 200px;
            scroll-snap-align: start;
            min-width: 0;
            text-align: left;
            position: relative;
            transition: transform var(--joy-transition-duration-short) var(--joy-transition-timing-function);
            box-sizing: border-box;

            &:not(:first-child)::after {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: -16px;
                border-left: 1px solid var(--joy-color-neutral-30);
            }

            @include mq.screen_md(min) {
                width: 100%;

                &:hover {
                    transform: scale(1.05);
                }

                &:not(:first-child)::after {
                    left: -32px;
                }
            }
        }

        &__logo {
            height: 28px;
            width: auto;
            max-width: 140px;
            object-fit: contain;
            object-position: left center;
            filter: grayscale(100%);
            margin-bottom: var(--joy-core-spacing-3);

            &--bigger {
                height: 56px;
            }

            &--color {
                filter: none;
            }
        }

        &__quote {
            margin: 0;
            font-size: var(--joy-font-size-primary-400);
            line-height: var(--joy-line-height-large);
            margin-bottom: var(--joy-core-spacing-3);
        }

        &__author {
            margin: auto 0 0;
            color: var(--joy-color-neutral-40);
            font-size: var(--joy-font-size-primary-200);
            line-height: var(--joy-line-height-small);
            text-transform: uppercase;
        }
    }
</style>
